export const withMissingTranslationFallback = (messagesObject, defaultTranslation = { id: 'const.spaceSymbol', defaultMessage: ' ' }) =>
  new Proxy(messagesObject, {
    get(obj, key) {
      if (key in obj) return obj[key];

      console.error("can't find key", key, 'in', obj);
      return defaultTranslation;
    },
  });
